import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from '@chakra-ui/react';
import CompaniesTable from './components/CompaniesTable';
import EmployeeStatusTable from './components/EmployeeStatusTable';
import Organizations from '../organizations/Organizations';

function isSuperAdmin() {
  try {
    const userInfo = JSON.parse(localStorage.getItem('user'));
    return !!(userInfo && userInfo.screens && userInfo.screens.includes('tools'));
  } catch {
    return false;
  }
}

export default function Companies() {
  const showEmployeeStatus = isSuperAdmin();

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Tabs align="start" variant="enclosed" isLazy lazyBehavior="unmount">
        <TabList>
          <Tab>חברות</Tab>
          <Tab>ארגונים</Tab>
          {showEmployeeStatus && <Tab>סטטוס עובדים</Tab>}
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <CompaniesTable />
          </TabPanel>
          <TabPanel px={0}>
            <Organizations />
          </TabPanel>
          {showEmployeeStatus && (
            <TabPanel px={0}>
              <EmployeeStatusTable />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
}
